import { SxProps } from '@mui/material'

const paginationWrapper: SxProps = {
  mt: '40px',
  width: 'max-content',
  minHeight: '32px',
  mr: { xs: 'auto', lg: '30px' },
  '& ul': {
    width: { xs: '320px', sm: 'auto' },
    justifyContent: 'space-between',
  },
}

const Styles = {
  paginationWrapper,
}

export default Styles
